<template>
    <div id="novel_success">
        <div class="novel_success1 cursor_1" @click="toHome">
            <img src="@/assets/image/icon_right.png" alt="">
            创建作品
        </div>
        <div class="novel_success2">
            <div class="novel_success3">
                <img :src="iconSelect[5]" alt="">
                作品创建成功
            </div>
            <div class="novel_success4">
                <img :src="novelInfo.cover" alt="">
            </div>
            <div class="novel_success5 cursor_1" @mouseover="hover" @mouseout="out" @click="openCover">
                <img :src="fmIcon" alt="">
                选择封面
            </div>
            <div class="novel_success6">
                <div class="novel_success7 cursor_1" @click="toInfo">编辑信息</div>
                <div class="novel_success7 novel_success8 cursor_1" @click="toEditor(0)">我有分卷</div>
                <div class="novel_success7 novel_success9 cursor_1" @click="toEditor(1)">AI生成分卷</div>
            </div>
            <!-- <div class="novel_success6" v-if="type === 'outline'">
                <div class="novel_success7 cursor_1" @click="toInfo">编辑信息</div>
                <div class="novel_success7 novel_success8 cursor_1" @click="toEditor(0)">我有大纲</div>
                <div class="novel_success7 novel_success9 cursor_1" @click="toEditor(1)">AI生成大纲</div>
            </div> -->
        </div>
        <novelLongCover ref="createCover" @changeCover="changeCover"></novelLongCover>
        <NovelLongSeriesPopup ref="novelLongSeriesPopup" @allCreate="allCreate" @submit="partCreate"></NovelLongSeriesPopup>
    </div>
</template>

<script>
import api from '@/api/api';
import lNApi from '@/api/longNovel';
import data from '@/assets/data';
import novelLongCover from "@/components/long_novel/novel_long_cover.vue"
import AiCreate from '@/pages/novelTurnScript/aiCreate.vue';
import { EncryptionUtil } from '@/utils/encrypt'
import NovelLongSeriesPopup from './novel_long_series_popup.vue';
export default {
    props: {
        successNovelId: {
            type: [Number, String],
        },
        type: String
    },
    components: {
        novelLongCover, NovelLongSeriesPopup
    },
    data() {
        return {
            iconSelect: data.iconSelect,
            fmIcon: data.iconSelect[6],
            novelInfo: {}, //小说信息
        }
    },
    created() {
        this.getNovellist(this.successNovelId)
    },
    methods: {
        // 悬停事件
        hover() {
            this.fmIcon = this.iconSelect[7]
        },
        out() {
            this.fmIcon = this.iconSelect[6]
        },
        // 返回首页
        toHome() {
            // this.$router.replace({ path: '/novel' });
            // this.$emit('toList')
            this.$router.go(-1)
        },
        getNovellist(id) {
            console.log('获取小说详情=', id)
            lNApi.longNovelDetail({ id }).then((res) => {
                if (res.code == 200) {
                    this.novelInfo = res.data
                }
            })
        },
        //打开封面
        openCover() {
            this.$refs.createCover.open(this.novelInfo.id)
        },
        // 切换封面
        changeCover(item) {
            lNApi.longNovelCoverUpdate({
                id: this.novelInfo.id,
                image: item
            }).then((res) => {
                if (res.code == 200) {
                    this.novelInfo.cover = item
                    this.$message.success('修改封面成功！')
                }
            })
        },
        //去生成大纲 0.手写，1.ai生成
        toEditor(i) {
            //手写
            if (i === 0) {
                this.$router.replace({ path: '/seriesOutlineImport', query: { novelInfo: EncryptionUtil.encrypt(this.novelInfo), successNovelId: this.novelInfo.id } })
                return
            }
            if (this.novelInfo.series > 5) {
                this.$refs.novelLongSeriesPopup.open()
            } else {
                this.AiCreateEditor(i,this.novelInfo.series)
            }
        },
        //全部分卷生成
        allCreate(){
          this.AiCreateEditor(1,0)
        },
        //生成部分
        partCreate(num){
             this.AiCreateEditor(1,num)
        },
        AiCreateEditor(i,snum=0) {
            let item = {
                id: this.novelInfo.id,
                novelInfo: this.novelInfo,
                editType: i + 1,
                backNum: 1,
                isAiCreate: i === 1 ? true : false,//表示是不是ai生成，ai续写的不算，目的是为了不让别在浏览器复制地址多开当前ai生成页面一直生成问题
                snum:snum
            }
            //编辑大纲在novel_list 页面
            sessionStorage.setItem('editItem', JSON.stringify(item))
            this.$router.replace({ path: '/seriesEditor' });
        },
        //编辑小说信息
        toInfo() {
            this.$router.replace({ path: '/longNovelEdit', query: { copy: false, successNovelId: this.successNovelId } });
        }
    }
}
</script>
<style>
#novel_success {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 10px;
    padding: 35px 30px;
}

.novel_success1 {
    font-weight: bold;
    font-size: 19px;
    color: #111111;
    display: flex;
    align-items: center;
}

.novel_success1 img {
    width: 23px;
    height: 23px;
    margin-right: 5px;
}

.novel_success2 {
    width: 300px;
    display: flex;
    flex-flow: column;
    align-items: center;
    margin: 0 auto;
    padding-top: 100px;
}

.novel_success3 {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 19px;
    color: #111111;
}

.novel_success3 img {
    width: 21px;
    height: 21px;
    margin-right: 5px;
}

.novel_success4 {
    width: 219px;
    height: 292px;
    border-radius: 10px;
    overflow: hidden;
    margin: 20px 0;
    object-fit: cover;
    display: flex;
}

.novel_success4 img {
    width: 100%;
    height: 100%;
    object-position: center;
    object-fit: cover;
    margin: auto;
}

.novel_success5 {
    font-size: 15px;
    color: #333333;
    display: flex;
    align-items: center;
}

.novel_success5:hover {
    color: var(--tech-primary);
}

.novel_success5 img {
    width: 21px;
    height: 21px;
    margin-right: 5px;
}

.novel_success6 {
    width: 446px;
    display: flex;
    justify-content: space-between;
    margin-top: 60px;
}

.novel_success7 {
    width: 142px;
    height: 42px;
    text-align: center;
    line-height: 42px;
    font-size: 15px;
    color: #333333;
    background: #EEEEEE;
    border-radius: 8px;
}

.novel_success8 {
    color: var(--tech-primary);
    background: var(--tech-btn-Lightblue);
}

.novel_success9 {
    color: #FFFFFF;
    background: var(--tech-primary);
}

.novel_success9:hover {
    background-color: var(--tech-primary);
}
</style>